import React, { Component } from "react";
import "./OrderProgressStateGuide.scss";
import IOrder_Progress_State from "../../../../models/IOrder_Progress_State";
import ISupplierModel from "../../../../models/ISupplierModel";
import OrderStatesEnum from "../../../../models/OrderStatesEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import * as _ from "lodash-es";

type Props = {
    orderStates: IOrder_Progress_State[];
    currentStateId: OrderStatesEnum;
    supplierModel: ISupplierModel;
};

type State = {
    // width: number,
    currentStep: IOrder_Progress_State | null;
    nextStep: IOrder_Progress_State | null;
};

class OrderProgressStateGuide extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const { currentStep, nextStep } = this.getSteps();

        this.state = {
            currentStep,
            nextStep,
        };
    }

    getSteps = (): { currentStep: IOrder_Progress_State; nextStep: IOrder_Progress_State | null } => {
        const currentStep = this.props.orderStates.find((state) => {
            return state.order_state_id === this.props.currentStateId;
        })!;

        let nextStep: IOrder_Progress_State | null = null;

        for (let i = 0; i < this.props.orderStates.length; ++i) {
            const state = this.props.orderStates[i];

            if (state && currentStep && state.order_state_id === currentStep.order_state_id) {
                if (i + 1 < this.props.orderStates.length) {
                    nextStep = this.props.orderStates[i + 1];
                }
            }
        }

        return { currentStep, nextStep };
    };

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.currentStateId !== this.props.currentStateId) {
            const { currentStep, nextStep } = this.getSteps();

            this.setState({
                currentStep,
                nextStep,
            });
        }
    }

    componentDidMount() {
        // let lastOrderState = this.props.orderStates[this.props.orderStates.length - 1];
        //
        // const lastStateElem = document.getElementById(`progress-${lastOrderState.name}`);
        //
        // if (lastStateElem) {
        //     let left = lastStateElem.offsetLeft;
        //
        //     this.setState({
        //         width: left
        //     })
        // }
    }

    render() {
        const { currentStep, nextStep } = this.getSteps();

        let currentStepIndex = -1;
        let nextStepIndex = -1;
        let supplierAdminROIndex = -1;
        let supplierUserROIndex = -1;
        let vendorUserROIndex = -1;

        for (let i = 0; i < this.props.orderStates.length; ++i) {
            const step = this.props.orderStates[i];

            if (step.isSupplierAdminReadOnly) {
                supplierAdminROIndex = i;
            }

            if (step.isSupplierReadOnly) {
                supplierUserROIndex = i;
            }

            if (step.isVendorReadOnly) {
                vendorUserROIndex = i;
            }

            if (step.order_state_id === currentStep?.order_state_id) {
                currentStepIndex = i;
            }

            if (step.order_state_id === nextStep?.order_state_id) {
                nextStepIndex = i;
            }
        }

        const supplierAdminReadOnly = supplierAdminROIndex <= currentStepIndex;
        const supplierUserReadOnly = supplierUserROIndex <= currentStepIndex;
        const vendorUserReadOnly = vendorUserROIndex <= currentStepIndex;

        return (
            <div className="OrderProgressStateGuide">
                <div>
                    <OwLabel title={"this_step_is"} isBold={true} isUnderline={true} postText={":"} />
                    <div className={"ms-2"}>
                        {supplierAdminReadOnly ? (
                            <OwLabel title={"supplier_admin_read_only"} />
                        ) : (
                            <OwLabel title={"supplier_admin_editable"} />
                        )}
                    </div>
                    <div className={"ms-2"}>
                        {supplierUserReadOnly ? (
                            <OwLabel title={"supplier_user_read_only"} />
                        ) : (
                            <OwLabel title={"supplier_user_editable"} />
                        )}
                    </div>
                    {this.props.supplierModel.has_customer_module ? (
                        <div className={"ms-2"}>
                            {vendorUserReadOnly ? (
                                <OwLabel
                                    title={"vendor_user_read_only"}
                                    isSupplierVendorOverride={true}
                                    supplierModel={this.props.supplierModel}
                                />
                            ) : (
                                <OwLabel
                                    title={"vendor_user_editable"}
                                    isSupplierVendorOverride={true}
                                    supplierModel={this.props.supplierModel}
                                />
                            )}
                        </div>
                    ) : null}
                </div>
                {nextStep ? (
                    <div>
                        <OwLabel title={"at_this_step_upon_submit"} isBold={true} isUnderline={true} postText={":"} />
                        <div>
                            {nextStep?.sendEmail ? (
                                <div className={"ms-2"}>
                                    <OwLabel title={"send_email"} className={"me-2"} />
                                </div>
                            ) : null}
                            {nextStep?.email ? (
                                <div className={"ms-2"}>
                                    <OwLabel title={"email_sent_to"} className={"me-2"} postText={":"} />
                                    {nextStep.email}
                                </div>
                            ) : null}
                            {nextStep?.email_user ? (
                                <div className={"ms-2"}>
                                    <OwLabel title={"user_that_created_order_gets_emailed"} />
                                </div>
                            ) : null}

                            {nextStep?.email_vendor ? (
                                <div className={"ms-2"}>
                                    <OwLabel
                                        title={"vendor_gets_emailed"}
                                        isSupplierVendorOverride={true}
                                        supplierModel={this.props.supplierModel}
                                    />
                                </div>
                            ) : null}

                            {nextStep?.emailPDFPackingList ? (
                                <div className={"ms-2"}>
                                    <OwLabel title={"email_pdf_packing_list"} />
                                </div>
                            ) : null}

                            {nextStep?.calculateShippingAt ? (
                                <div className={"ms-2"}>
                                    <OwLabel title={"shipping_at_gets_calculated"} />
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                <div>
                    <OwLabel title={"this_step_is_advanced_by"} isBold={true} isUnderline={true} postText={":"} />
                    <div>
                        {!_.isNil(nextStep) ? (
                            <div className={"ms-2"}>
                                <OwLabel title={"supplier_admin"} />
                            </div>
                        ) : null}
                        {nextStep && !nextStep.isAdminOnlyStep ? (
                            <div className={"ms-2"}>
                                <OwLabel title={"supplier_user"} />
                            </div>
                        ) : null}
                        {this.props.supplierModel.has_customer_module && nextStep?.isVendorStep ? (
                            <div className={"ms-2"}>
                                <OwLabel title={"vendor"} isSupplierVendorOverride={true} supplierModel={this.props.supplierModel} />
                            </div>
                        ) : null}
                        {_.isNil(nextStep) ? (
                            <div className={"ms-2"}>
                                <OwLabel title={"nobody"} />
                            </div>
                        ) : null}
                    </div>
                    <OwLabel title={"note_admin_users_can_always_change_to_a_different_step"} />
                </div>

                {/*<div>*/}
                {/*    <OwLabel title={'supplier'}/>*/}
                {/*    <div>*/}
                {/*        <div>*/}
                {/*            <OwLabel title={'admin'}/>*/}
                {/*            <div className={'line'} id={'supplier-admin-line'}>*/}
                {/*                <hr className={'border-white'} style={{width: `${this.state.width}px`}}/>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        <div>*/}
                {/*            <OwLabel title={'sales'}/>*/}
                {/*            <div className={'line'} id={'supplier-sales-line'}>*/}
                {/*                <hr className={'border-white'}/>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div>*/}
                {/*    <OwLabel title={'vendor'}/>*/}
                {/*    <div>*/}
                {/*        <div>*/}
                {/*            <OwLabel title={'all'}/>*/}
                {/*            <div className={'line'} id={'vendor-all-line'}>*/}
                {/*                <hr className={'border-white'}/>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default OrderProgressStateGuide;
